module.exports = __webpack_public_path__ + "1.5.0-unryo/img/rabbitmq.3938d65c.svg";